<app-header [demo]="demo" theme="create-campaign"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
